// src/components/StoreNavbar.js
import React from 'react';
// Import your logo image
import storeLogo from '../assets/images/store-logo.jpeg'; // Update this path to your actual logo

const StoreNavbar = ({ totalItems, onCartClick }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-[#3E5645]/10 px-4 py-3 shadow-sm">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        {/* Left side - Pushed fully to the left */}
        <div className="flex items-center gap-2">
          <img 
            src={storeLogo} 
            alt="Store Logo" 
            className="rounded-full object-cover"
            style={{ width: '36px', height: '36px' }}
          />
          <span className="text-[#3E5645] font-bold text-lg hidden sm:inline" style={{ fontFamily: "'Fraunces', serif" }}>
            MBU Learning Store
          </span>
          <span className="text-[#3E5645] font-bold text-lg sm:hidden" style={{ fontFamily: "'Fraunces', serif" }}>
            MBU Learning Store
          </span>
        </div>

        {/* Right side - Pushed fully to the right */}
        <div className="flex items-center gap-3">
          {/* Cart Button */}
          <button
            onClick={onCartClick}
            className="relative text-[#3E5645] hover:text-[#2F6FED] transition-colors p-2 hover:bg-[#FBF9F2] rounded-full"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            {totalItems > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#2F6FED] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center border-2 border-white shadow-sm">
                {totalItems}
              </span>
            )}
          </button>

          {/* Trust Badge */}
          <div className="hidden md:flex items-center gap-1 text-xs text-[#6B7A6E] bg-[#FBF9F2] px-3 py-1.5 rounded-full">
            <span className="text-[#E8B84B]">★</span>
            <span>4.8/5</span>
            <span className="text-[#3E5645]">•</span>
            <span>Trusted</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreNavbar;